var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/components/pv.template.html');

var TheView = GenericView.extend({
    el: '#pv',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "pv");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
    },
    events: {
        'change input[name="parametric_analysis"]': 'checkParametricAnalysis',
        "change input.slider": "fillTextBoxWithSliderValue",
        "input .input-slider": "changeSliderValue",
        "input .to-validation input": "validateIt"
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    checkParametricAnalysis: function() {
        $("#pv .disabled").find(".addVal").addClass("to-validation");
        $("#pv").find(".disabled").removeClass("disabled");
        $("#pv ." + $("input[name='parametric_analysis']:not(:checked)").val()).addClass("disabled");
        $("#pv .disabled").find(".addVal").removeClass("to-validation");
    },
    fillTextBoxWithSliderValue: function(event) {
        $input_id = $(event.currentTarget).data("input-id");
        $input_value = $(event.currentTarget).val();
        $("#" + $input_id).val($input_value);
    },
    changeSliderValue: function(event) {
        var slider_data_id = $(event.currentTarget).attr('id');
        var input_value = $(event.currentTarget).val();
        $('[data-input-id="' + slider_data_id + '"]').val(input_value);
    },
    getAllData: function() {
         var data = {
             pv_parametricflag: $("input[name='parametric_analysis']:checked").val(),
             pv_cap: this.convertToFloat("#pv_cap"),
             pv_min: this.convertToFloat("#pv_min"),
             pv_max: this.convertToFloat("#pv_max"),
             pv_inv_cost: this.convertToFloat("#pv_inv_cost"),
             pv_oper_cost: this.convertToFloat("#pv_oper_cost"),
             slope: this.convertToFloat("#slope"),
             azimuth: this.convertToFloat("#azimuth"),
             inv_eff: this.convertToFloat("#inv_eff"),
             deg_f: this.convertToFloat("#deg_f")
         };

         return data;
     }
});

module.exports= TheView;